/**
 * 获取指定车型详细参数
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'
// // 获取车辆基本信息
// // 接口地址  /api/v1/auctions/bidders/{auction_id}
// Mock.mock(/\/auctions\/bidders\/\d+/, 'get' + mockSwitch, {
//   'code': 0,
//   'message': 'ok',
//   'data': {
//     'bidder': {
//       'actived_at': '2018-01-05 10:52:34',
//       'address': '南山',
//       'city': '深圳市',
//       'city_code': '440300',
//       'created_at': '2018-01-03 11:36:26',
//       'district': 'gg',
//       'district_code': 'gg',
//       'garage_name': '南山',
//       'garage_type': 1,
//       'garage_type_name': '二手车经销商',
//       'id': 37,
//       'mobile_number': '18665368712',
//       'name': '涂蓉',
//       'province': '广东省',
//       'province_code': '440000',
//       'status': 1,
//       'status_code': 'active'
//     },
//     'operator': {
//       'id': 62,
//       'mobile_number': '13692295284',
//       'name': '王蒙',
//       'role_id': null,
//       'role_name': '**行政经理,**二手车经理,**售后经理,所有权限,**销售经理,**结算会计',
//       'store_name': '中升测试环境店铺'
//     }
//   }
// })

// 车商信息+get
// 接口地址 /api/v1/used_car/dealer/user/<int:user_id>
Mock.mock(/used_car\/dealer\/user\/\d+$/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'organization': {
      'id': 1, // # 车商组织id
      'organization_type': '4S店', // # 车商类型
      'name': '车商组织名',
      'legal_person_name': '法人姓名',
      'province': '省份',
      'city': '城市',
      'address': '详细地址',
      'store': {
        'name': '门店名称',
        'city': '东莞'
      }
    },
    'user': {
      'id': 1, // # 车商用户id
      'name': '当前用户姓名',
      'mobile_number': '15914039388',
      'created_at': '2012-12-12 12:12:12' // # 创建/添加时间
    }
  }
})
